import { createAnalyticsEvent } from 'analytics/create-analytics-event';
import { GAEventName } from 'analytics/ga-event-name.enum';

import { CheckoutType } from './ecommerce';

export const closeCart = createAnalyticsEvent(() => ({
  event: GAEventName.CLOSE_CART,
  checkout_type: 'unified' satisfies CheckoutType
}));
